import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {takeUntil} from 'rxjs/operators';

import {Destroyable} from '../../destroyable.component';
import {ReportDefinition} from '../../models/models.interfaces';
import {ReportDefinitionService} from '../../shared/employees/report-definition/report-definition.service';

@Component({
  selector: 'gp-report-list',
  templateUrl: './report-list.component.html'
})
export class ReportListComponent extends Destroyable implements OnInit {

  @Input()
  public reports: Array<ReportDefinition>;

  @Output()
  public selectedReport: EventEmitter<ReportDefinition> = new EventEmitter<ReportDefinition>();

  triggerSortByTranslationPipe = true;

  constructor(private translate: TranslateService,
              public reportDefinitionService: ReportDefinitionService) {
    super();
  }

  ngOnInit() {
    this.translate.onLangChange
      .asObservable()
      .pipe(
        takeUntil(this.componentDestroyed$)
      )
      .subscribe(() => {
        this.triggerSortByTranslationPipe = !this.triggerSortByTranslationPipe;
      });
  }

  public selectAndEmitReport(report: ReportDefinition): void {
    this.selectedReport.emit(report);
  }

}
